import Intercom from '@/components/intercom/intercom';
import { MeProvider, useMe } from '@/context/me/me.context';
import useAnalyticsPageViews from '@/hooks/use-analytics-view-page';
import { useGetFooterIsVisible } from '@/queries/layout.queries';
import { Flex } from '@cmpsr/components';
import React from 'react';
import { Navigate, Outlet, ScrollRestoration, useLocation } from 'react-router-dom';
import FooterDashboard from '../dashboard/footer-dashboard/footer-dashboard';
import { ROUTE_SIGN_IN, ROUTE_ACCOUNT } from '@/constants/routes';
import authService from '@/services/auth.service';

function AuthGuard({ children }: { children: React.ReactNode }): React.ReactNode {
  const { data: me } = useMe();
  const location = useLocation();

  if (!me) {
    authService.logout(); // This just removes the token from local storage
    return <Navigate to={ROUTE_SIGN_IN} />;
  }

  // Redirect canceled users to account page (unless they're already there or on edit-membership)
  if (me.userLevel === 'canceled' && !location.pathname.startsWith(ROUTE_ACCOUNT)) {
    return <Navigate to={ROUTE_ACCOUNT} replace />;
  }

  return children;
}

export default function MainLayout(): React.ReactElement {
  const { data: isFooterVisible } = useGetFooterIsVisible();
  useAnalyticsPageViews();

  return (
    <Flex flexDirection="column" minHeight="100vh" background="background-page">
      <MeProvider>
        <AuthGuard>
          <Outlet />
          <Intercom />
          <ScrollRestoration />
        </AuthGuard>
      </MeProvider>
      {isFooterVisible && <FooterDashboard />}
    </Flex>
  );
}
